import React, { useState, useRef, useEffect } from "react";
import {
  findTimeBefore,
  findTimeAfter,
} from "shared/itemLists/redux/caseLogic/timeValidationFunctions";
import TimeInputs from "globalComponents/TimeInputs";
import { DateHelper } from "shared/helpers/DateHelper";
import {
  setTimeCorrectionObject,
  finishMovingItem,
  updateItem,
} from "shared/itemLists/redux/itemListsSlice";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

function TimeCorrectionPane(props) {
  const {
    items,
    oldIndexAbs,
    newIndexAbs,
    newIndex,
    finishMovingItem,
    setTimeCorrectionObject,
    updateItem,
  } = props;
  const item = items[oldIndexAbs];
  const [itemTime, setItemTime] = useState(item.time);
  const [errorMessage, setErrorMessage] = useState("");

  const hourRef = useRef(null);

  useEffect(() => {
    hourRef.current.select();
  }, []);

  useEffect(() => {
    if (isItemTimeCorrect()) {
      setErrorMessage("");
    }
  }, [itemTime]);

  function timeInMinutes() {
    return DateHelper.toMinutes(itemTime);
  }

  const prettyType = { task: "a task", appointment: "an appointment" }[
    item.type
  ];
  const timeName = { task: "deadline ", appointment: "starting time " }[
    item.type
  ];
  const timeBefore = findTimeBefore(items, oldIndexAbs, newIndexAbs);
  const timeAfter = findTimeAfter(items, oldIndexAbs, newIndexAbs);
  function timeRelationshipPhrase() {
    console.log("before and after", timeBefore, timeAfter);
    if (timeBefore && timeAfter) {
      return "between " + timeBefore.time + " and " + timeAfter.time;
    } else if (timeBefore) {
      return "after " + timeBefore.time;
    } else if (timeAfter) {
      return "before " + timeAfter.time;
    }
  }

  function handleUndoMoveClick() {
    setTimeCorrectionObject({ isOpen: false });
  }

  function isItemTimeCorrect() {
    const beforeCorrect =
      !timeBefore || timeBefore.time_in_minutes <= timeInMinutes();
    const afterCorrect =
      !timeAfter || timeAfter.time_in_minutes >= timeInMinutes();
    return beforeCorrect && afterCorrect;
  }

  function handleSaveClick() {
    if (isItemTimeCorrect()) {
      finishMovingItem();
      setTimeCorrectionObject({ isOpen: false });
      updateItem({
        attributes: { time: itemTime, time_in_minutes: timeInMinutes() },
        method: { type: "index", index: newIndex },
      });
    } else {
      setErrorMessage("Invalid time");
    }
  }

  function handleKeyUp(event) {
    if (event.key === "Enter") {
      setTimeout(() => {
        handleSaveClick();
      }, 100);
    }
  }

  return (
    <>
      {
        <div
          onKeyDown={handleKeyUp}
          className="time-correction-backdrop backdrop"
        >
          <div className="Time-correction-pane pane">
            <span className="explanation">
              {"Moving " +
                prettyType +
                " to that position requires a " +
                timeName +
                timeRelationshipPhrase()}
            </span>
            <div className="error-message">{errorMessage}</div>
            <div className="flex-center-div">
              <TimeInputs
                itemTime={itemTime}
                setItemTime={setItemTime}
                hourRef={hourRef}
              />
            </div>
            <div>
              <button
                className="undo-move-button"
                onClick={handleUndoMoveClick}
              >
                Undo Move
              </button>
              <button className="save-button" onClick={handleSaveClick}>
                Save Move
              </button>
            </div>
          </div>
        </div>
      }
    </>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { setTimeCorrectionObject, finishMovingItem, updateItem },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(TimeCorrectionPane);
